import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const PrevButtonComponent = ({ onClick, children, disabled }) => {
  return (
    <TooltipComponent content="Preview" id="preview-tooltip" placement="top">
      <ButtonComponent type="button" color="secondary mb-1" onClick={onClick} disabled={disabled}>
        <IconComponent icon="Preview" height="18" />
        &nbsp;{children}
      </ButtonComponent>
    </TooltipComponent>
  )
}

PrevButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
}

export default PrevButtonComponent
